export function transferEventDateText(datetimeAry) {
  let datetimeText = ''
  let currentYear = ''
  let computeDatetimeAry = JSON.parse(JSON.stringify(datetimeAry))
  // sort 會影響到 datetimeAry 重複觸發update
  // const todayMidnight = new Date().setHours(0, 0, 0, 0) // set to today midnight
  computeDatetimeAry.sort((a, b) => a - b).forEach((value, index) => {
    let datetime = new Date(value * 1000)
    // if (datetime.getTime() <= todayMidnight) return

    let y = datetime.getFullYear()
    let m = datetime.getMonth() + 1
    let d = datetime.getDate()
    if (index === 0) datetimeText += y + '-'
    else if (index !== 0 && y !== currentYear) {
      currentYear = y
      datetimeText += `${currentYear}-`
    }
    m = m > 9 ? m : `0${m}` // 個位數補 0
    d = d > 9 ? d : `0${d}` // 個位數補 0
    datetimeText += `${m}-${d}`
    if (index < datetimeAry.length - 1) datetimeText += '、'
  })
  return datetimeText
}

export function transferEventVenueText(venueAry) {
  if (venueAry && venueAry.length > 0) {
    return venueAry.map(venue => (venue.venue_name || venue.venueName)).join('、')
  } else {
    return ''
  }
}
